// @ts-nocheck

import { Box, CircularProgress, IconButton, Fab } from '@mui/material';
import { useState, useEffect } from 'react';
import { Image } from 'components-new';
import getRatio from '@/utils/getRatio';

type Props = {
  ratio: string;
  sx?: any;
  src: string;
  previewSrc: string;
  whitelabel?: any;
};

export default function IframeResponsive({
  ratio,
  sx,
  src,
  previewSrc,
  whitelabel,
  ...other
}: Props) {
  const [play, setPlay] = useState(false);
  const [loading, setLoading] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Escape') {
        setFullScreen(false);
      }
    }

    if (fullScreen) {
      document.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [fullScreen]);

  return (
    <Box id="3_d_tour" sx={{ borderRadius: '5px', overflow: 'hidden' }}>
      {(!play || loading) && (
        <Image
          alt="hero"
          src={previewSrc}
          ratio={ratio}
          overComponent={
            <IconButton
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                color: '#fff',
                borderRadius: '50%',
                fontSize: '77px',
                width: '77px',
                height: '77px',
                zIndex: 9,
                '.fa-duotone:after': {
                  opacity: 1,
                },
              }}
              onClick={() => {
                setLoading(true);
                setPlay(true);
              }}
            >
              {loading ? (
                <CircularProgress size={50} />
              ) : (
                <i
                  className="fas fa-circle-play"
                  style={{
                    '--fa-primary-color': '#fff',
                    '--fa-secondary-color': whitelabel?.primaryColor || '#2055ff',
                  }}
                />
              )}
            </IconButton>
          }
        />
      )}

      {play && (
        <Box
          component="span"
          sx={{
            width: 1,
            lineHeight: 1,
            display: 'block',
            overflow: 'hidden',
            position: 'relative',
            pt: loading ? '0' : getRatio(ratio),
            '& .wrapper': {
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              lineHeight: 0,
              position: fullScreen ? 'fixed' : 'absolute',
              zIndex: fullScreen ? 999 : 0,
              backgroundSize: 'cover !important',
            },
            ...sx,
          }}
        >
          {!loading && (
            <Fab
              size="small"
              onClick={() => setFullScreen((prev) => !prev)}
              sx={{
                background: 'white',
                boxShadow: 'none',
                position: fullScreen ? 'fixed' : 'absolute',
                bottom: '12px',
                right: '10px',
                zIndex: 9999,
              }}
            >
              <i
                className={`fa-regular ${fullScreen ? 'fa-compress' : 'fa-expand'}`}
                style={{ fontSize: '20px' }}
              />
            </Fab>
          )}
          <Box className="wrapper">
            <iframe
              src={src}
              style={{ width: '100%', height: '100%' }}
              onLoad={() => setLoading(false)}
              {...other}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
